<template>
  <div class="row">
    <div class="col-12 col-md-3">
      <ProspectIntermediator  v-if="$can(abilities.VIEW_OPPORTUNITIES) || $can(abilities.VIEW_ALL_OPPORTUNITIES)" :pipeline="getPipeline" />
      <Partner v-if="$can(abilities.VIEW_OPPORTUNITIES) || $can(abilities.VIEW_ALL_OPPORTUNITIES)" @load="loadPipelineData" :right="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)" :partners="partners" @loadUsers="reloadUsers" :users="users" :pipeline="getPipeline"/>
      <Criterias v-if="!$can(abilities.OPPORTUNITIES_STATE_CHANGE)" :pipeline="getPipeline" @load="loadPipelineData"/>
      <OpportunityFilesManagement v-if="$can(abilities.VIEW_OPPORTUNITIES) || $can(abilities.VIEW_ALL_OPPORTUNITIES)" :right="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)" :pipeline="getPipeline" :files="getPipeline?.files" @filesUploaded="loadPipelineData" @reset="resetData"/>
    </div> 

    <div class="col-12 col-md-9">
      <Card :title="$t('pipelines.info_pipelines')" containerClass="mb-5">
        <template #cardToolbar>
          <div class="d-flex justify-content-end align-items-center" v-show="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)">
            <div>
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" btn-text="button.cancel" @click="resetData" :is-disabled="getPipeline?.status == 'WON' || getPipeline?.status == 'LOST' || getPipeline.status == 'ARCHIVED'"></Button>
              <Button v-if="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)" btn-class="btn-sm me-3" type="new" id="submit_btn" btn-text="button.save" @click="updatePipeline('save')" :is-loading="isLoadingPipeline" :is-disabled="getPipeline?.status == 'WON' || getPipeline?.status == 'LOST' || getPipeline.status == 'ARCHIVED'"></Button>
              <Button v-if="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)" btn-class="btn-sm" type="new" id="submit_btn" btn-text="button.save_close" @click="updatePipeline('close')" :is-loading="isLoadingClosePipeline" :is-disabled="getPipeline?.status == 'WON' || getPipeline?.status == 'LOST' || getPipeline.status == 'ARCHIVED'"></Button>
            </div>
          </div>                                               
        </template>
        <template #cardBody>
          <RequiredText/>
          <div class="row">
            <div class="col-12 col-md-12 d-flex align-items-center">
              <Input
                containerClass="flex-grow-1 me-1 mt-2 mb-2"
                name="name"
                type="text"
                :label="$t('pipelines.label.label')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :isRequired="true" size="lg"
                v-model="formData.name"
                :placeholder="$t('pipelines.label.name_placeholder')"
              />
              <InputRating
                v-if="pipelinePriorities.length"
                :priorities="pipelinePriorities"
                v-model="formData.priority"
                description="pipelines.rating_text"
                container-class="ms-1 mt-6 mb-2" 
                :label="$t('pipelines.label.priority')"
              />
            </div>
          </div>

          <div class="row">
            <InputAmount :number="formData.expected_income" :iso="defaultCurrency?.symbol" :required="true" @amount="getAmount" containerClass="col-12 col-md-6 mt-2 mb-2"/>
            <Select2
              :is-required="true"
              container-class="col-12 col-md-6 mt-2 mb-2"
              :multiple="false"
              :show-search="true"
              :selectClass="'form-select form-control-lg form-select-solid'"
              name="pipelines-creator"
              :label="$t('pipelines.label.creator')"
              label-class="form-label"
              v-model="formData.seller_id"
              :placeholder-text="$t('pipelines.label.select_creator')"
            >
                <option v-for="user in users" :value="user.id" :key="user.id">
                  {{ user.lastname }} {{ user.firstname }}
                </option>            
            </Select2>
          </div>

          <div class="row">
            <Select2
                :is-required="true"
                :container-class="selectedContactSociety.length > 0 ? 'col-12 col-md-6 mb-5' : 'col-12 col-md-12 mb-5'"
                :multiple="false"
                :show-search="true"
                :selectClass="'form-select form-control-lg form-select-solid'"
                name="pipelines-prospect"
                :label="$t('pipelines.label.prospect')"
                label-class="form-label"
                :placeholder-text="$t('pipelines.label.select_prospect')"
                v-model="formData.contact_id"
                :IsInputGroup="$can(abilities.CREATE_CONTACT)"
                icon="bi bi-plus"
                :clickAddon="openProspectModal"
            >
                <option v-for="contact in contacts" :value="contact.id" :key="contact.id">
                  {{ contact.lastname }} {{ contact.firstname }}
                </option>
            </Select2>

            <div class="col-12 col-md-6" v-if="selectedContactSociety.length > 0">
              <Select2
                  :is-required="false"
                  container-class="col-12 col-md-12 mb-5"
                  :multiple="true"
                  :show-search="true"
                  :selectClass="'form-select form-control-lg form-select-solid'"
                  name="pipelines-intermediator"
                  :label="$t('pipelines.label.intermediator')"
                  label-class="form-label"
                  :placeholder-text="$t('pipelines.label.select_intermediator')"
                  v-model="formData.collaborators"
                  :IsInputGroup="$can(abilities.CREATE_CONTACT)"
                  icon="bi bi-plus"
                  :clickAddon="openContactModal"
              >
                  <option v-for="contact in getIntermediators" :value="contact.id" :key="contact.id">
                    {{ contact.lastname }} {{ contact.firstname }}
                  </option>
              </Select2>
            </div>
          </div>
          
          <div class="row">
            <Select2
                :is-required="false"
                container-class="col-12 col-md-6 mt-2 mb-2"
                :multiple="false"
                :show-search="true"
                :selectClass="'form-select form-control-lg form-select-solid'"
                name="pipelines-source_prospect"
                :label="$t('pipelines.label.source')"
                label-class="form-label"
                v-model="formData.opportunity_source_id"
                :placeholder-text="$t('pipelines.label.select_source')"
            >
              <option v-for="(source, index) in sources" :value="source.id" :key="source.id" >
                {{ source.name }}
              </option>
            </Select2>

            <Select2
                  :is-required="true"
                  container-class="col-12 col-md-6 mt-2 mb-2"
                  :multiple="false"
                  :show-search="true"
                  :selectClass="'form-select form-control-lg form-select-solid'"
                  name="pipelines-state"
                  :label="$t('pipelines.label.state')"
                  label-class="form-label"
                  v-model="formData.opportunity_state_id"
                  :isDisabled="!$can(abilities.OPPORTUNITIES_STATE_CHANGE)"
                  :placeholder-text="$t('pipelines.label.select_state')"
            >
                <option v-for="(pipelineStat, index) in activePipelines" :value="pipelineStat.id" :key="pipelineStat.id" >
                  {{ pipelineStat.name }}
                </option>
            </Select2>
            
          </div>

          <div class="row">
            <InputDate2
                containerClass="col-12 col-md-3 mt-2 mb-2"
                name="pipelines-start_date"
                :label="$t('pipelines.label.start_date')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :isRequired="false" size="lg"
                v-model="formData.creation_date"
                :placeholder="$t('pipelines.label.start_date')"
            />
            <InputDate2
                containerClass="col-12 col-md-3 mt-2 mb-2"
                name="pipelines-closing_date"
                :label="$t('pipelines.label.opportunity_closing_date')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :isRequired="false" size="lg"
                v-model="formData.closing_date"
                :placeholder="$t('pipelines.label.opportunity_closing_date')"
            />
            <Select2
                :is-required="false"
                container-class="col-12 col-md-6 mb-2 mt-2"
                :multiple="true"
                :show-search="true"
                :selectClass="'form-select form-control-lg form-select-solid'"
                name="pipelines-tags"
                :label="$t('pipelines.label.tags')"
                label-class="form-label"
                :placeholder-text="$t('pipelines.label.select_tags')"
                :IsInputGroup="$can(abilities.CREATE_TAG)"
                v-model="formData.tags"
                icon="bi bi-plus"
                :clickAddon="openTagModal"
            >
              <option v-for="(tag, index) in tags" :value="tag.id" :key="tag.id" >
                {{ tag.name }}
              </option>
            </Select2>
          </div>

          <Select2
              :is-required="false"
              container-class="col-12 col-md-12 mb-2 mt-2"
              :multiple="true"
              :show-search="true"
              :selectClass="'form-select form-control-lg form-select-solid'"
              name="pipelines-products"
              :label="$t('pipelines.label.products')"
              label-class="form-label"
              v-model="formData.products"
              :placeholder-text="$t('pipelines.label.select_products')"
          >
              <option v-for="(item, index) in items" :key="index" :value="item.id">{{ item.declination_title }} </option>
          </Select2>

         <div >
            <CKEditor id="kt_ck_editor2" :required="false" :label="$t('pipelines.label.notes')" :content="formData.description" container-class="col-12 col-md-12 mb-2 mt-2" @text="getDescription" />
          </div>
        </template>
        <template #cardFooter>
          <div class="d-flex justify-content-end" v-show="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" btn-text="button.cancel" @click="resetData" :is-disabled="getPipeline?.status == 'WON' || getPipeline?.status == 'LOST' || getPipeline.status == 'ARCHIVED'"></Button>
            <Button v-if="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)" btn-class="btn-sm me-3" type="new" id="submit_btn" btn-text="button.save" @click="updatePipeline('save')" :is-loading="isLoadingPipeline" :is-disabled="getPipeline?.status == 'WON' || getPipeline?.status == 'LOST' || getPipeline.status == 'ARCHIVED'"></Button>
            <Button v-if="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)" btn-class="btn-sm" type="new" id="submit_btn" btn-text="button.save_close" @click="updatePipeline('close')" :is-loading="isLoadingClosePipeline" :is-disabled="getPipeline?.status == 'WON' || getPipeline?.status == 'LOST' || getPipeline.status == 'ARCHIVED'"></Button>
          </div>
        </template>
      </Card>


    </div>
  </div>
  <Create id="create" @load="reloadTags" @add-tag="getTag"></Create>
  <div class="modal fade" tabindex="-1" id="contactCreateModal">
    <div class="modal-dialog modal-xl">
      <CreateContact id="contactCreateModal"
                      :get-countries="countries"
                      :contact="formCustomerData"
                      :parent="id"
                      :modal="true"
                      @success="afterCreateNewContact"/>
    </div>
  </div>


</template>

<script setup>
import {BASE_IMAGE_URL} from "@/services/api";
import Card from "@/Modules/CRM/components/Card.vue";
import Button from "@/components/Button.vue"
import {computed, onMounted, ref, watch} from "vue";
import i18n from "@/plugins/i18n";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import Input from "@/components/Input.vue";
import InputAmount from "@/components/InputAmount.vue"
import InputDate2 from "@/components/InputDate2.vue"
import Select2 from "@/components/Select2.vue"
import CKEditor from "@/components/CKEditor.vue"
import Create from '@/Modules/CRM/components/Modals/Tag/CreateTag.vue'
import CreateContact from "@/components/contact/CreateContact.vue";
import InputRating from "@/components/InputRating.vue"
import OpportunityFilesManagement from "@/Modules/CRM/views/Pipeline/components/OpportunityFilesManagement";
import ProspectIntermediator from "@/Modules/CRM/views/Pipeline/components/ProspectIntermediator";
import Partner from "@/Modules/CRM/views/Pipeline/components/Partner";
import RequiredText from "@/components/RequiredText";
import abilities from "@/composables/abilities";
import Criterias from "./Criterias.vue";

const store = useStore()
const router = useRouter()
const route = useRoute()

const emits = defineEmits(['data-updated'])

const props = defineProps({
  pipeline: Object
})

const getPipeline = ref(props.pipeline)
const initialData = ref({})

const partners = ref([])

const formData = ref({
  id: null,
  name: "",
  expected_income: "0",
  creation_date: null,
  closing_date: null,
  opportunity_source_id: "",
  creator_id: "",
  seller_id: "",
  contact_id: "",
  description: "",
  priority: 0,
  opportunity_state_id: '',
  products: [],
  collaborators: [],
  tags: [],
  files: []
})

const formCustomerData = ref({
    id: null,
    gender: null,
    contactType: 'particular',
    lastname: null,
    firstname: null,
    address: {
        street: null,
        street2: null,
        city: null,
        zipcode: null,
        country: null
    },
    customer: false,
    birthday: null,
    supplier: true,
    propspect: false,
    telephone: [],
    previewAvatar: BASE_IMAGE_URL + '/assets/blank.png',
    email: null,
    website: null,
    company_id: '',
    collaborators: []
})

const isLoadingPipeline = ref(false)
const isLoadingClosePipeline = ref(false)
const selectedContact = ref('')

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])
const countries = computed(() => store.getters['countries/getCountries'])
const users = computed(() => store.getters['user/getUsers'])
const contacts = computed(() => store.getters['contacts/getContacts'])
const activePipelines = computed(() => store.getters['pipelines/getActivePipelines'])
const pipelinePriorities = computed(() => store.getters['pipelines/pipelinePriorityEnum'])
const items = computed(() => store.getters['products/getProductSaleElements'])
const tags = computed(() => store.getters['tags/getTags'])
const sources = computed(() => store.getters['sources/getSources'])
const getIntermediators = computed(() => contacts.value.filter((contact) => contact.company_id == formData.value.contact_id))
const selectedContactSociety = computed(() => contacts.value.filter((contact) => contact.contactType == 'society' && contact.id == formData.value.contact_id))

watch(() => props.pipeline, (value) => {
  getPipeline.value = props.pipeline
})

watch(() => formData.value.contact_id, (value) => {
  if(value){
    formData.value.collaborators = []
  }
})

watch(() => getPipeline.value, (value) => {
  formData.value.id = getPipeline.value.id,
  formData.value.name = getPipeline.value.name,
  formData.value.expected_income = getPipeline.value.expected_income,
  formData.value.creation_date = getPipeline.value.creation_date || null,
  formData.value.closing_date = getPipeline.value.closing_date,
  formData.value.opportunity_source_id = getPipeline.value.source?.id || null,
  formData.value.seller_id = getPipeline.value.seller_id,
  formData.value.contact_id = getPipeline.value.contact_id,
  formData.value.creator_id = getPipeline.value.creator_id,
  formData.value.description = getPipeline.value.description != "null" ? getPipeline.value.description : " ",
  formData.value.priority = getPipeline.value.priority,
  formData.value.opportunity_state_id = getPipeline.value.opportunityState?.id,
  formData.value.products = getPipeline.value.productSaleElements.map(item => item.id),
  formData.value.collaborators = getPipeline.value.collaborators.map(item => item.id),
  formData.value.tags = getPipeline.value.tags.map(item => item.id)
  formData.value.files = []
  getPipeline.value?.files?.forEach(fileData => {
      let file = fileData.file.split('.')
      let type = getFileType(file[file.length-1])
      formData.value.files.push({ name: fileData.file, size: fileData.size || 0, url: fileData.file_url, type: type })
  });
})

function getFileType(type){
  let mimeType = ''

  switch (type) {
    case 'pdf':
      mimeType = 'application/pdf';
      break;
    case 'doc':
      mimeType = 'application/msword';
      break;
    case 'docx':
      mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'jpeg':
    case 'jpg':
      mimeType = 'image/jpeg';
      break;
    case 'png':
      mimeType = 'image/png';
      break;
    default:
      mimeType = '';
  }

  return mimeType;
}



function openTagModal() {
  $('#createTagModal_create').modal('toggle')
}

function openProspectModal() {
  selectedContact.value = 'prospect'
  $('#contactCreateModal').modal('toggle')
}

function openContactModal() {
  selectedContact.value = 'intermediator'
  $('#contactCreateModal').modal('toggle')
}

function getDescription(text){
  formData.value.description = text
}

function getAmount(amount){
  formData.value.expected_income = amount
}

function getTag(tag){
  formData.value.tags.push(tag)
}

function afterCreateNewContact(contact){
    reloadContacts()
    if(selectedContact.value = 'prospect'){
      formData.value.contact_id = contact.id
    }else{
      formData.value.collaborators.push(contact.id)
    }
    
    formCustomerData.value = {
      id: null,
      gender: null,
      contactType: 'particular',
      lastname: null,
      firstname: null,
      address: {
      street: null,
      street2: null,
      city: null,
      zipcode: null,
      country: null
      },
      customer: false,
      birthday: null,
      supplier: true,
      telephone: [],
      previewAvatar: BASE_IMAGE_URL + '/assets/blank.png',
      email: null,
      website: null,
      company_id: '',
      collaborators: []
    }
}

function loadData () {
  Promise.all([
      store.dispatch('company/generalInformation'),
      store.dispatch('pipelines/loadPipelinePrioritiesEnum'),
      store.dispatch('pipelines/loadPipelineStates'),
      store.dispatch('pipelines/loadPipelineFeelingEnum'),
      store.dispatch('countries/loadCountries'),
      store.dispatch('sources/loadSources')
  ])
}

async function reloadContacts() {
  await store.dispatch('contacts/loadContacts')
}

async function reloadTags() {
  await store.dispatch('tags/loadTags')
}

async function reloadUsers() {
  await store.dispatch('user/loadUsers')
}

function loadPipelineData(){
  store.dispatch('pipelines/getPipeline', route.params.id).then((res) => {
    getPipeline.value = res.data?.data
    initialData.value = res.data?.data
    partners.value = res.data?.data?.followers
    emits('data-updated', getPipeline.value)
  })
}

function resetData(){
  loadPipelineData()
}

function updatePipeline(action){
    if(action == 'close'){
      isLoadingClosePipeline.value = true
    }else{
      isLoadingPipeline.value = true
    }

    let data = {
      id: formData.value.id,
      name: formData.value.name,
      expected_income: formData.value.expected_income,
      creation_date: formData.value.creation_date,
      closing_date: formData.value.closing_date,
      opportunity_source_id: formData.value.opportunity_source_id,
      creator_id: formData.value.creator_id,
      seller_id: formData.value.seller_id,
      contact_id: formData.value.contact_id,
      description: formData.value.description,
      priority: formData.value.priority,
      opportunity_state_id: formData.value.opportunity_state_id,
      products: formData.value.products,
      collaborators: formData.value.collaborators,
      tags: formData.value.tags
    }

    store.dispatch('pipelines/updatePipeline', data)
    .then(res => {
      loadPipelineData()
      window.toastr['success'](i18n.global.t("notification.pipeline_updated"))
      if(action == 'close'){
        router.push('/admin/crm/pipeline')
      }
    })
    .catch((err) => {
        if(action == 'close'){
          isLoadingClosePipeline.value = false
        }else{
          isLoadingPipeline.value = false
        }
    }).finally(() => {
      if(action == 'close'){
        isLoadingClosePipeline.value = false
      }else{
        isLoadingPipeline.value = false
      }
    })
}

onMounted(() => {
  reloadContacts()
  reloadTags()
  loadData()
  reloadUsers()
  store.dispatch('products/loadAllProductSale')
  loadPipelineData()
})

</script>

<style scoped>
</style>
